import { render, staticRenderFns } from "./ButtonTwoTone.vue?vue&type=template&id=34c86e99&scoped=true"
import script from "./ButtonTwoTone.vue?vue&type=script&lang=js"
export * from "./ButtonTwoTone.vue?vue&type=script&lang=js"
import style0 from "./ButtonTwoTone.vue?vue&type=style&index=0&id=34c86e99&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c86e99",
  null
  
)

export default component.exports